export const CLASS_TYPES = {
  GROUP: 'group',
  PRIVATE: 'private',
};

export const LIVE_INSTRUCTION_CLASS_TYPES = {
  [CLASS_TYPES.GROUP]: 'GROUP',
  [CLASS_TYPES.PRIVATE]: '1_1',
};

export const USER_ROLES = {
  TEACHER: 'teacher',
  ADMIN: 'admin',
};

export const CLASS_ATTENDANCE_STATUSES = {
  ATTENDED: 'attended',
  CANCELLED: 'canceled',
  NO_SHOW: 'no show',
  RESERVED: 'reserved',
};

export const FEATURES = {
  MY_SCHEDULE: 'my-schedule',
  CLASS_DETAIL: 'class-detail',
  SUBMIT_PRIVATE_CLASS_FEEDBACK: 'submit-private-class-feedback',
  CREATE_BULK_GROUP_CLASS: 'create-bulk-group-class',
  EDIT_GROUP_CLASS: 'edit-group-class',
  CANCEL_GROUP_CLASS: 'cancel-group-class',
  EDIT_PRIVATE_CLASS: 'edit-private-class',
  ALL_CLASSES: 'all-classes',
  TEACHERS: 'teachers',
  CREATE_SINGLE_AND_RECURRING_GROUP_CLASS: 'create-single-and-recurring-group-class',
  VIEW_PRIVATE_CLASS_FEEDBACK: 'view-private-class-feedback',
  UPDATE_PRIVATE_CLASS_FEEDBACK: 'update-private-class-feedback',
  ALL_CLASSES_DOWNLOAD_REPORTS: 'all-classes-download-reports',
  MY_SCHEDULE_DOWNLOAD_REPORTS: 'my-schedule-download-reports',
  LESSONS: 'lessons',
  BULK_DELETE_CLASSES: 'bulk-delete-classes',
  EDIT_USER_PERMISSIONS: 'edit-user-permissions',
  ASSIGN_LESSONS_TO_LEARNERS_BY_GUARDIAN_PERMISSIONS: 'assign-lesson-to-learners-by-guardian-permissions',
  ASSIGN_LESSON_TO_LEARNERS_IN_MY_CLASSES: 'assign-lesson-to-learners-in-my-classes',
  CAN_BULK_EDIT_PRIVATE_CLASS_CREDITS: 'can-bulk-edit-private-class-credits',
  LI_AVAILABILITY_SET_IN_LI_SERVICE: 'li-availability-set-in-li-service',
  MANAGE_TEACHERS_ENROLLMENT: 'manage-teachers-enrollment',
  MANAGE_TEACHERS_RESTRICTED_SETTINGS: 'manage-teachers-restricted-settings',
  CAN_CHANGE_POLICIES_AND_PLANS: 'can-change-policies-and-plans',
  PROGRAM_BULK_ALLOCATE_PRIVATE_CLASS_HOURS: 'program-bulk-allocate-private-class-hours',
  EXTERNAL_FUNDING_PROGRAM_INSPECTOR: 'external-funding-program-inspector',
  PROGRAM_REFUND_HOURS: 'program-refund-hours',
  HIDE_LEARNER_EMAIL: 'hide-learner-email',
};

export const CLASS_CANCEL_STATUSES = {
  CANCELED_BY_USER: 'CANCELED_USER',
  CANCELED_BY_TUTOR: 'CANCELED_TUTOR',
  CANCELED: 'CANCELED',
};

export const MEDIA_TYPES = {
  ARTICLE: 'article',
  CONVERSATION: 'conversation',
  IMAGE: 'image',
  VIDEO: 'video',
};

export const ORGANIZATION_PERMISSIONS = {
  organization_admin: 3,
  organization_add: 2,
  organization_modify: 1,
  organization_view: 0,
};

export const GROUP_PERMISSIONS = {
  group_admin: 3,
  group_add: 2,
  group_modify: 1,
  group_view: 0,
};

export const PERMISSION_LABELS = {
  0: 'View',
  1: 'Modify',
  2: 'Add',
  3: 'Admin',
};

export default {
  CLASS_CANCEL_STATUSES,
  CLASS_TYPES,
};

export const modalDefaults = {
  classes: 'v--modal v--modal_theme_dark',
  clickToClose: false,
  height: 'auto',
  scrollable: true,
};

export const FAVICONS = {
  voxy: '//drfglkcvoj903.cloudfront.net/static_df5e8474d28115b17684c6e8e099e568/img/favicon.ico',
  engen: 'https://voxy-partners.s3.amazonaws.com/engen.ico',
};

export const PAGE_TITLES = {
  voxy: 'Voxy Command Center',
  engen: 'Command Center',
};

export const DEFAULT_COURSE_LANGUAGE = {
  language_id: 'en',
  english_name: 'English',
};

export const DEFAULT_CLASS_POLICY = {
  name: 'Default',
};

export const DEFAULT_CLASS_TYPE = {
  type: 'GROUP_OPEN',
  label: 'Group Open',
};

export const DEFAULT_TIMEZONE = 'UTC';

export const TEMPLATE_FILES = {
  editPrivateClasses:
    'https://drfglkcvoj903.cloudfront.net/static/csv/Command+Center/bulk_edit_private_class_credits_template.csv',
  editLearners: 'https://drfglkcvoj903.cloudfront.net/static/csv/Command+Center/edit_multiple_learners_template.csv',
  uploadClasses: 'https://drfglkcvoj903.cloudfront.net/static/csv/Command+Center/bulk_upload_classes_template.csv',
  uploadClassesWithLessons:
    'https://drfglkcvoj903.cloudfront.net/static/csv/Command+Center/bulk_upload_classes_with_lessons_template.csv',
  uploadClassesWorkshops:
    'https://drfglkcvoj903.cloudfront.net/static/csv/Command+Center/bulk_upload_classes_workshops_template.csv',
  uploadLearners: 'https://drfglkcvoj903.cloudfront.net/static/csv/Command+Center/add_multiple_learners_template.csv',
  allocatePrivateClassHours:
    'https://drfglkcvoj903.cloudfront.net/static/csv/Command+Center/bulk_allocate_private_class_hours_template.csv',
};

export const CUSTOMER_PACKAGES = {
  // License type keys
  CREDIT_TYPE_PRIVATE_TUTORING: 'private_tutoring',
  // License subtype keys
  LICENSE_SUBTYPE_PRIVATE_CLASS_CONTRACT_END_CREDIT: 'license_subtype_private_class_contract_end_credit',
};

export const ConversationsFeatureConfigurationSlug = 'live-instruction-conversations';
